import React from "react";
import { Helmet } from "react-helmet";
import siteConfig from "../../../data/siteConfig";
import PropsHead from "../../types/PropsHead";

const Head = (props: PropsHead) => {
  const { data } = props;
  const title = data ? data.title : siteConfig.title;
  const author = data ? data.author : siteConfig.author;
  const description = data ? data.description : siteConfig.description;
  const image = data ? data.image : siteConfig.image;
  const url = data ? data.url : siteConfig.url;

  return (
    <Helmet>
      {/* General tags */}
      <html lang="en" />
      <title>{title}</title>
      <meta name="author" content={author} />
      <meta name="description" content={description} />
      <meta name="image" content={image} />
      <meta name="keywords" content={siteConfig.keywords} />

      {/* OpenGraph tags */}
      <meta property="og:title" content={title} />
      <meta property="og:author" content={author} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />

      {/* Twitter Card tags */}
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
    </Helmet>
  );
};

export default Head;
